<template lang='pug' src='./team-gallery.pug'></template>

<script>
export default {
  props: ['content']
}
</script>



// WEBPACK FOOTER //
// team-gallery.vue?4f70d06f